import { Box, Button, Center, Stack } from "@chakra-ui/react";
import { RevealVertically } from "@raiden/library/components/Animations/RevealVertically";
import { RGrid } from "@raiden/library/components/RGrid";
import { useSearchInfiniteContext } from "@raiden/library/contexts/SearchInfinite/useSearchInfiniteContext";
import { Fragment } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { ArticleCard } from "../../../components/Articles/Card";
import { DataHandlerInfinite } from "../../../components/DataHandlerInfinite";
import { Splash } from "../../../components/Splash";

export function Results() {
  const intl = useIntl();

  /** @type {import("@raiden/library/contexts/SearchInfinite/useSearchInfiniteContext").UseSearchInfiniteReturn<import(".").NewsSearchFormValues, import("@raiden/library/types/Post").Post[]>} */
  const { swrInfiniteResponse, reset } = useSearchInfiniteContext();

  return (
    <DataHandlerInfinite
      swrInfiniteResponse={swrInfiniteResponse}
      noResult={
        <Box py="13rem">
          <Splash
            title={intl.formatMessage({ defaultMessage: "Aucun résultat" })}
            description={intl.formatMessage(
              {
                defaultMessage:
                  "Nous ne trouvons pas d'article correspondant à votre recherche,{br}vous pouvez essayer de réduire le nombre de critères.",
              },
              {
                br: <br />,
              },
            )}
            addon={
              <Button onClick={reset} colorScheme="brandPrimary" size="lg">
                <FormattedMessage defaultMessage="Réinitialiser les filtres" />
              </Button>
            }
          />
        </Box>
      }>
      {(pages) => (
        <Box>
          <Stack spacing="0">
            {pages.map((page, index) =>
              index === 0 ? (
                <>
                  <RGrid gridGap="0" minCellWidth="460px">
                    {page.data
                      ?.filter((post, index) => index <= 1)
                      .map((post) => (
                        <ArticleCard post={post} key={post.id} />
                      ))}
                  </RGrid>

                  {(() => {
                    const otherPosts = page.data?.filter(
                      (post, index) => index > 1,
                    );
                    if (otherPosts?.length === 0) {
                      return null;
                    }

                    return (
                      <RGrid gridGap="0" minCellWidth="340px">
                        <Fragment key={index}>
                          {otherPosts.map((post) => (
                            <ArticleCard post={post} key={post.id} />
                          ))}
                        </Fragment>
                      </RGrid>
                    );
                  })()}
                </>
              ) : (
                <RGrid gridGap="0" minCellWidth="340px">
                  {page.data?.map((post) => (
                    <ArticleCard post={post} key={post.id} />
                  ))}
                </RGrid>
              ),
            )}
          </Stack>

          <RevealVertically isVisible={pages.length < pages[0].meta.last_page}>
            <Center pt="1rem">
              <Button
                onClick={() => {
                  swrInfiniteResponse.setSize((size) => size + 1);
                }}
                isLoading={swrInfiniteResponse.isValidating}
                colorScheme="brandPrimary"
                variant="outline"
                size="lg">
                <FormattedMessage defaultMessage="Plus de résultats" />
              </Button>
            </Center>
          </RevealVertically>
        </Box>
      )}
    </DataHandlerInfinite>
  );
}
